import { IFavoritesState } from '../states'
import { FavoritesActionTypes, FavoriteTypeKeys } from '../types'

export const initialFavoritesState: IFavoritesState = {
  favorites: [],
  isFetchingFavorites: false,
  isFetchingMoreFavorites: false,
  size: 10,
  page: 1,
  isLoadMoreExist: false,

  isLoadingFavorite: false,
  selectedReservation: null,
  selectedFavorite: null
}

const favorites = (
  state: IFavoritesState = initialFavoritesState,
  action: FavoritesActionTypes
): IFavoritesState => {
  switch (action.type) {
    case FavoriteTypeKeys.FETCHING_FAVORITES:
      return { ...state, isFetchingFavorites: true }
    case FavoriteTypeKeys.FETCH_FAVORITES_SUCCESSFUL:
      return {
        ...state,
        isFetchingFavorites: false,
        page: 2,
        isLoadMoreExist: action.payload.length < state.size ? false : true,
        favorites: action.payload
      }
    case FavoriteTypeKeys.FETCHING_MORE_FAVORITES:
      return { ...state, isFetchingMoreFavorites: true }
    case FavoriteTypeKeys.FETCH_MORE_FAVORITES_SUCCESSFUL:
      return {
        ...state,
        isFetchingMoreFavorites: false,
        page: state.page + 1,
        isLoadMoreExist: action.payload.length < state.size ? false : true,
        favorites: [ ...state.favorites, ...action.payload]
      }
    case FavoriteTypeKeys.SET_SELECTED_RESERVATION_MODAL:
      return {
        ...state,
        isLoadingFavorite: false,
        selectedReservation: action.payload
      }
    case FavoriteTypeKeys.ADDING_FAVORITE:
      return { ...state, isLoadingFavorite: true }
    case FavoriteTypeKeys.ADD_FAVORITE_SUCCESSFUL:
      return {
        ...state,
        isLoadingFavorite: false,
        selectedReservation: null
      }
    case FavoriteTypeKeys.SET_SELECTED_FAVORITE_MODAL:
      return {
        ...state,
        isLoadingFavorite: false,
        selectedFavorite: action.payload
      }
    case FavoriteTypeKeys.REMOVING_FAVORITE:
      return { ...state, isLoadingFavorite: true }
    case FavoriteTypeKeys.REMOVE_FAVORITE_SUCCESSFUL:
      return {
        ...state,
        isLoadingFavorite: false,
        selectedFavorite: null
      }
    default:
      return state
  }
}

export default favorites
